import { render, staticRenderFns } from "./MultipleChoicesDropdown.vue?vue&type=template&id=5bd14e92&"
import script from "./MultipleChoicesDropdown.vue?vue&type=script&lang=js&"
export * from "./MultipleChoicesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoicesDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports